import {useState} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {AxiosError} from 'axios'
import * as bootstrap from 'bootstrap'
import Select from 'react-select'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import style from './content-styles.module.css'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import uploadPlugin from './ImageUploadAdapterPlugin'
import {KTSVG} from '../../../../../_metronic/helpers'
import {SuccessfulNotify, UnsuccessfulNotify} from '../../../../../ToastMetods'
import {contentTypeList} from '../../../../../IOTFYEDUTypeList'
import {saveContent} from '../../../../modules/auth/core/_requests'
import {useLang} from '../../../../../_metronic/i18n/Metronici18n'

const profileDetailsSchema = Yup.object().shape({
  contentType: Yup.number().required('Content Type is required'),
})
function ContentEditModal({editData, setAction}: any) {
  const lang = useLang()

  const [file, setFile] = useState('')

  const handleFileChange = (e: any) => {
    const selectedFile = e.target.files[0]
    setFile(selectedFile)
  }

  const nowDate = () => {
    const d = new Date()
    return d.toISOString()
  }

  const initialValues = {
    contentType: Number(editData?.contentType) || 0,
    metadata: String(editData?.metadata) || '',
    contentTitle: editData?.contentTitle || '',
    contentText: editData?.contentText || '',
    spot: editData?.spot || '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: async (values) => {
      try {
        const model = {
          ContentType: values.contentType,
          ReleaseDate: nowDate(),
          Metadata: values.metadata,
          DilCode: lang,
          ContentTitle: values.contentTitle,
          ContentText: values.contentText,
          Spot: values.spot,
        }
        if (file) {
          const formData = new FormData()
          formData.append('id', String(editData.id))
          formData.append('ContentType', String(values.contentType))
          formData.append('ReleaseDate', nowDate())
          formData.append('Metadata', values.metadata)
          formData.append('DilCode', lang)
          formData.append('ContentTitle', values.contentTitle)
          formData.append('ContentText', values.contentText)
          formData.append('Spot', values.spot)
          formData.append('FileId', '0')
          formData.append('uploadFile', file)

          const {data} = await saveContent(formData)
        } else {
          const formData = new FormData()
          formData.append('id', String(editData.id))
          formData.append('ContentType', String(values.contentType))
          formData.append('ReleaseDate', nowDate())
          formData.append('Metadata', values.metadata)
          formData.append('DilCode', lang)
          formData.append('ContentTitle', values.contentTitle)
          formData.append('ContentText', values.contentText)
          formData.append('Spot', values.spot)
          formData.append('FileId', editData.fileId)
          formData.append('uploadFile', '')

          const {data} = await saveContent(formData)
        }
        formik.resetForm()
        //Modal close
        const modal = bootstrap.Modal.getOrCreateInstance('#updateContent_modal')
        modal.hide()
        //
        SuccessfulNotify('Successfully updated.')
        setAction(true)
      } catch (err) {
        const error = `${(err as AxiosError)?.response?.data}`
        console.error(error)
        UnsuccessfulNotify(String(error))
      }
    },
  })

  const optionContentTypeList = contentTypeList.map((item: any) => ({
    value: item.id,
    label: String(item.name),
  }))

  return (
    <div
      className='modal fade'
      tabIndex={-1}
      id='updateContent_modal'
      data-bs-focus='false'
      style={style}
    >
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>Edit Content</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
              <div className='modal-body'>
                {/*From*/}

                <div className='mb-10'>
                  <label className='form-label'>Content Type</label>
                  <Select
                    options={optionContentTypeList}
                    placeholder='Select Content Type'
                    onChange={(e) => formik.setFieldValue('contentType', Number(e?.value))}
                    value={optionContentTypeList.filter(
                      (item) => item.value === formik.getFieldProps('contentType').value
                    )}
                  />
                  {formik.touched.contentType && formik.errors.contentType && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.contentType}</div>
                    </div>
                  )}
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Metadata</label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Metadata'
                    {...formik.getFieldProps('metadata')}
                  />
                  {formik.touched.metadata && formik.errors.metadata && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.metadata}</div>
                    </div>
                  )}
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Content Title</label>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Content Title'
                    {...formik.getFieldProps('contentTitle')}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Content Text</label>
                  <CKEditor
                    editor={Editor}
                    data={formik.getFieldProps('contentText').value}
                    config={{
                      // @ts-ignore
                      extraPlugins: [uploadPlugin],
                    }}
                    onChange={(event: any, editor: any) => {
                      const data = editor.getData()
                      formik.setFieldValue('contentText', data)
                    }}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label'>Spot</label>
                  {/*}
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Spot'
                    {...formik.getFieldProps('spot')}
                  />
                  {*/}
                  <CKEditor
                    editor={Editor}
                    data={formik.getFieldProps('spot').value}
                    config={{
                      // @ts-ignore
                      extraPlugins: [uploadPlugin],
                    }}
                    onChange={(event: any, editor: any) => {
                      const data = editor.getData()
                      formik.setFieldValue('spot', data)
                    }}
                  />
                </div>

                <div className='mb-10'>
                  <label className='form-label'>File</label>
                  <br />

                  <input
                    type='file'
                    id='fileInput'
                    className={'form-control'}
                    onChange={handleFileChange}
                  />
                </div>
                {/*End Form */}
              </div>
              <div className='modal-footer'>
                <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                  Close
                </button>

                <button type='submit' className='btn btn-primary'>
                  Save Content
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentEditModal
